export default __webpack_public_path__ + "static/4-fa362b837cca4c125c7fed137f4519df.jpeg";